<div class="row mt-2">
    <div class="col-md-4">
        <mat-slide-toggle [(ngModel)]="isChecked" (change)="notifyParent()">Make Anonymous?</mat-slide-toggle>
    </div>
</div>
